import { render } from "./InspectionTempDetail.vue?vue&type=template&id=2ae932fc"
import script from "./InspectionTempDetail.vue?vue&type=script&lang=js"
export * from "./InspectionTempDetail.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__